import { render, staticRenderFns } from "./detail_m.vue?vue&type=template&id=42c090ec&scoped=true"
import script from "./detail_m.vue?vue&type=script&lang=js"
export * from "./detail_m.vue?vue&type=script&lang=js"
import style0 from "./detail_m.vue?vue&type=style&index=0&id=42c090ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c090ec",
  null
  
)

export default component.exports